import Image from 'next/image';
import batman from '@app/assets/images/batman.svg';
import NothingFound from '@app/components/NothingFound';
import styled from 'styled-components';

const SearchNothingFoundState = () => {
  return (
    <StyledNothingFound
      title="По запросу ничего не найдено"
      text={
        <>
          {'Попробуйте изменить параметры поиска или '}
          <StyledLink
            href="https://wa.me/+79198707755"
            target="_blank"
            rel="noreferrer"
          >
            свяжитесь с менеджером
          </StyledLink>
          .
        </>
      }
      img={
        <Image
          src={batman.src}
          width={212}
          height={135}
          alt="Здесь изображена летучая мышь, которая сидит на ветке"
        />
      }
    />
  );
};
export default SearchNothingFoundState;

const StyledLink = styled.a`
  color: #458fff;
`;

const StyledNothingFound = styled(NothingFound)`
  padding-top: 86px;
  padding-bottom: 86px;
`;
